import { RULE_GRAPH_VIEWPORT_CONTROL_HEIGHT } from "../ruleGraphControlDimensions/RULE_GRAPH_VIEWPORT_CONTROL_HEIGHT";
import { RULE_GRAPH_VIEWPORT_CONTROL_BOTTOM_INSET } from "../ruleGraphControlDimensions/RuleGraphControlInsets";

/**
 * Canvas margins for the initial view and Back to start. The bottom one
 * clears the zoom and Regenerate controls that sit along the canvas's bottom
 * edge, with the top margin's breathing room above them, so the whole rule is
 * in view when the canvas opens (ENG-7894).
 */
export const RULE_GRAPH_INITIAL_INSET = {
  left: 35,
  top: 23,
  bottom:
    RULE_GRAPH_VIEWPORT_CONTROL_BOTTOM_INSET +
    RULE_GRAPH_VIEWPORT_CONTROL_HEIGHT +
    23,
} as const;

export function initialRuleGraphViewport(
  bounds: { x: number; y: number; width: number; height: number },
  size: { width: number; height: number },
  minZoom: number
): { x: number; y: number; zoom: number } {
  const { left, top, bottom } = RULE_GRAPH_INITIAL_INSET;
  const fit = Math.min(
    (size.width - 2 * left) / Math.max(1, bounds.width),
    (size.height - top - bottom) / Math.max(1, bounds.height)
  );
  const zoom = Math.max(minZoom, Math.min(1, fit));
  return { x: left - bounds.x * zoom, y: top - bounds.y * zoom, zoom };
}
